/**
 * Who may change the cost figures a proposal quotes.
 *
 * ⚠️ OPENING A STEP AND REWRITING ITS NUMBERS ARE DIFFERENT RIGHTS.
 *
 * The per-step keys (see tenderStepPermissions.ts) answer "may this role open Step 8?". They do
 * not answer "may it change what the client is quoted?", and Step 8 is where those two part
 * company: it shows every retailer's energy / environmental / network / other figures, and a
 * pencil on each row types straight over them.
 *
 * Reported from a BROKER role set up for Steps 5-9: the broker could open Offer Details and edit
 * the costs, when the intent was for them to review the numbers and generate the proposal, not
 * to alter them. Removing Step 8 from the role would have hidden the figures they need to check,
 * so the right boundary is on the edit, not on the step.
 *
 * ⚠️ THE RECALCULATE BUTTON COUNTS AS AN EDIT.
 *
 * It types no number, but it overwrites every stored cost for the tender — a bigger change than
 * any single field, and the one that is hardest to notice afterwards. A role that may not edit a
 * figure may not replace all of them either.
 *
 * ⚠️ UI GATING ONLY, exactly as the step keys are. This hides the controls; it does not stop a
 * crafted call to the cost endpoints. That was the agreed scope — server enforcement is a
 * separate piece of work.
 */

/** Permission key for changing the cost figures shown on Offer Details (Step 8). */
export const COST_EDIT_PERMISSION = 'tender.costs.edit';

/**
 * May this role change cost figures?
 *
 * Admins always may — `can()` short-circuits for them, so nothing special is needed here.
 */
export const canEditCosts = (can: (permission: string) => boolean): boolean =>
  can(COST_EDIT_PERMISSION);
